<template>
  <v-card-text class="pa-0">
    <v-form ref="scheduleForm" @submit.prevent>
      <v-layout row wrap mb-3 v-if="schedule.condominium.name === ''">
        <v-spacer></v-spacer>
        <v-flex>
          <h5>
            CNPJ do empreendimento:
          </h5>
        </v-flex>
        <v-flex class="text-xs-center">
          <v-text-field
          name="nome"
          mask="##.###.###/####-##"
          :value="searchCnpj"
          @input="updateSearchCnpj"
          :disabled="loadingCondominium || loadingNew"
          v-if="schedule.condominium.id === ''"
          ></v-text-field>
          <!-- :append-icon-cb="teste" -->
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn  color="green darken-1" dark class="ma-0" @click="searchCondominiumCnpj"><v-icon class="mr-2">search</v-icon> pesquisar </v-btn>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <v-layout row wrap mb-3 v-else pa-3 style="background:#f3f3f3">
        <v-flex>
          <h5>
            CNPJ: {{ schedule.condominium.cnpj }}
          </h5>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right">
          <v-btn color="red darken-1" dark class="ma-0 ml-2" @click="newSearchCondominiumCnpj"><v-icon class="mr-2">autorenew</v-icon> nova pesquisa</v-btn>
        </v-flex>
      </v-layout>
      <v-layout class="pt-3 pb-3 mb-3" style="height:290px;" v-if="loadingCondominium">
        <v-flex class="text-xs-center">
          <v-progress-circular class="mt-5" size="80" indeterminate color="red"></v-progress-circular>
        </v-flex>
      </v-layout>
      <template v-else-if="schedule.condominium.name !== ''">
        <condominium-box :value="schedule"></condominium-box>
      </template>
      <v-layout class="pt-3 pb-3 mb-3" style="height:290px;" v-else-if="!errorSearchCnpj">
        <v-flex class="text-xs-center search-text">
          <img :src="require('@/assets/arrow-up.png')" alt="" class="mb-1"><br>
          Digite acima o CNPJ do empreendimento para
          <br>
          <template v-if="schedule.itens.length > 1">
            divulgar os itens
          </template>
          <template v-else>
            divulgar o iten
          </template>
          <br>          
          <v-btn            
            color="red"
            class="white--text"
            @click="removeScheduleItem(item)"
            v-for="item in schedule.itens" :key="item.id"
            >
            {{ item.name }}
            <v-icon right dark>close</v-icon>
          </v-btn>
          <hr/>
          <div class="link" @click="selectScheduleItem">            
            <template v-if="schedule.itens.length > 1">
              Deseja selecionar outros itens?
            </template>
            <template v-else>
              Deseja selecionar outro item?
            </template>
          </div>
        </v-flex>
      </v-layout>
      <v-layout class="pt-3 pb-3 mb-3" style="height:290px;" v-else>
        <v-flex class="text-xs-center search-text mt-5">
          CNPJ do empreendimento não encontrado
        </v-flex>
      </v-layout>
      <v-layout row wrap class="pt-3 mb-3 text-xs-center" v-if="schedule.condominium.name !== ''">
        <v-flex>
          <v-btn flat color="green" class="ma-0" @click="saveSchedule" :disabled="!canSend">Confirmar agendamento</v-btn>
        </v-flex>
      </v-layout>
    </v-form>    
  </v-card-text>
</template>


<script>
import condominiumBox from './CondominiumBox'

import cancelWarning from '../cancelWarning'
import sendEmail from '../SendEmail'
export default {
  name: 'search-condominium',
  components: {
    'cancel-warning': cancelWarning,
    'send-email': sendEmail,
    'condominium-box': condominiumBox
  },
  data () {
    return {
      loadingNew: false
    }
  },
  methods: {
    selectScheduleItem () {
      this.$store.commit('newSchedule', '')
    },
    removeScheduleItem (item) {
      this.$store.commit('removeScheduleItem', item)
    },
    alterSchedule () {
      this.$store.dispatch('alterSchedule')
    },
    saveSchedule () {
      if (this.$store.getters.disponibilityInterval) {
        this.$store.dispatch('setErrorDisponibilityInterval', false)
        this.$store.dispatch('saveSchedule', true)
      } else {
        this.$store.dispatch('setErrorDisponibilityInterval', true)
      }
    },
    newSearchCondominiumCnpj () {
      this.$store.commit('newSearchCondominiumCnpj')
    },
    searchCondominiumCnpj () {
      this.$store.dispatch('searchCondominiumCnpj')
    },
    updateScheduleCode (value) {
      this.$store.commit('updateScheduleCode', value)
    },
    updateSearchCnpj (value) {
      if (this.errorSearchCnpj) {
        this.$store.commit('errorSearchCnpj', false)
      }
      if (value.length < 14) {
        this.$store.commit('updateSearchCnpj', value)
      } else if (value.length === 14) {
        this.$store.commit('updateSearchCnpj', value)
        this.$store.dispatch('searchCondominiumCnpj')
      }
    },
    next () {
      return
    }
  },
  computed: {
    canSend () {
      return this.schedule.dates.length > 0 && !this.loadingScheduleActions
    },
    loadingScheduleActions () {
      return this.$store.getters.loadingScheduleActions
    },
    selectedScheduleIdChanged () {
      var idSelected = this.$store.getters.selectedScheduleIdChanged
      if (idSelected !== '') {
        this.$store.dispatch('selectSchedule', idSelected)
      }
      return idSelected
    },
    errorSearchCnpj () {
      return this.$store.getters.errorSearchCnpj
    },
    searchCnpj () {
      return this.$store.getters.searchCnpj
    },
    loadingCondominium () {
      return this.$store.getters.loadingCondominium
    },
    schedule () {
      return this.$store.getters.selectedSchedule
    },
    hasSelection () {
      return this.schedule.item !== null
    },
    registeredItems () {
      return this.$store.getters.registeredItems
    }
  }
}
</script>
<style>
.has-item{
  background: rgba(0, 0, 0, 0.32);
}
</style>



// WEBPACK FOOTER //
// SearchCondominium.vue?422fa1e8